import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const QKEY = "terreno_queue";
const RKEY = "terreno_sync_result";
const read = () => JSON.parse(localStorage.getItem(QKEY) || "[]");
const write = (q) => { localStorage.setItem(QKEY, JSON.stringify(q)); window.dispatchEvent(new Event("terreno:queue")); };
const isNetErr = (e) => !e.response;
const retryable = (e) => isNetErr(e) || [401, 408, 429].includes(e.response.status) || e.response.status >= 500;
const me = () => JSON.parse(localStorage.getItem("syc_user_cache") || "{}").id || null;
const mine = () => { const id = me(); return id ? read().filter((x) => x.user_id === id) : []; };
export const queuedFor = (url) => mine().filter((x) => x.url === url);
const detail = (e) => { const d = e.response?.data?.detail; return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(", ") : "rechazado"; };
const OK_RESULTS = ["entrada_registrada", "salida_registrada", "registrado", "ya_registrado"];

export const normRut = (t) => {
  let s = (t || "").trim();
  if (/^https?:\/\//i.test(s)) { try { s = new URL(s).searchParams.get("RUN") || ""; } catch { s = ""; } }
  return s.replace(/[.\s]/g, "").toUpperCase();
};

export const cachedGet = async (url, params) => {
  const key = `cache:${url}:${JSON.stringify(params || {})}`;
  try {
    const { data } = await api.get(url, { params });
    localStorage.setItem(key, JSON.stringify(data));
    return data;
  } catch (e) {
    const c = localStorage.getItem(key);
    if (isNetErr(e) && c) return JSON.parse(c);
    throw e;
  }
};

export const cacheRoster = (ot) => ot && cachedGet(`/rrhh/day/${ot}/roster`).catch(() => []);
export const findWorker = (ot, qr) => {
  const list = JSON.parse(localStorage.getItem(`cache:/rrhh/day/${ot}/roster:{}`) || "[]");
  const rut = normRut(qr);
  return list.find((w) => normRut(w.rut) === rut) || null;
};

export const send = async (url, body, label, meta = {}) => {
  if (navigator.onLine) {
    try { return { data: (await api.post(url, body)).data }; } catch (e) { if (!isNetErr(e)) throw e; }
  }
  const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  try {
    write([...read(), { id, url, label, meta, user_id: me(), body: { ...body, offline: true, client_ts: new Date().toISOString() } }]);
  } catch {
    toast.error("Memoria del teléfono llena: conéctese a internet para enviar los pendientes antes de seguir");
    throw Object.assign(new Error("quota"), { quota: true });
  }
  return { queued: true };
};

export const clearCaches = () => Object.keys(localStorage).filter((k) => k.startsWith("cache:")).forEach((k) => localStorage.removeItem(k));

let busy = false;
export const flush = async () => {
  if (busy || !navigator.onLine || !mine().length) return;
  busy = true;
  let ok = 0;
  let stopped = null;
  const errors = [];
  try {
    for (const item of mine()) {
      try {
        const { data } = await api.post(item.url, item.body);
        if (data.result && !OK_RESULTS.includes(data.result)) errors.push(`${item.label}: ${data.result.replace(/_/g, " ")}`);
        else ok += 1;
        (data.results || []).filter((r) => !r.ok).forEach((r) => errors.push(`${item.label} ${r.code}: ${r.error}`));
      } catch (e) {
        if (retryable(e)) { stopped = e.response?.status === 401 ? "Inicie sesión de nuevo para enviar los pendientes" : "Servidor no disponible: se reintentará"; break; }
        errors.push(`${item.label}: ${detail(e)}`);
      }
      write(read().filter((x) => x.id !== item.id));
    }
  } finally { busy = false; }
  if (ok || errors.length || stopped) {
    localStorage.setItem(RKEY, JSON.stringify({ at: new Date().toISOString(), ok, errors, stopped }));
    window.dispatchEvent(new Event("terreno:queue"));
  }
};

export const useQueue = () => {
  const snap = () => ({ online: navigator.onLine, pending: mine().length, last: JSON.parse(localStorage.getItem(RKEY) || "null") });
  const [s, setS] = useState(snap);
  useEffect(() => {
    const upd = () => setS(snap());
    const on = () => { upd(); flush(); };
    window.addEventListener("online", on);
    window.addEventListener("offline", upd);
    window.addEventListener("terreno:queue", upd);
    window.addEventListener("syc:user", on);
    flush();
    const t = setInterval(flush, 30000);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", upd); window.removeEventListener("terreno:queue", upd); window.removeEventListener("syc:user", on); clearInterval(t); };
  }, []);
  return s;
};

export const clearLast = () => { localStorage.removeItem(RKEY); window.dispatchEvent(new Event("terreno:queue")); };
